// AI-CONTEXT: See docs/features/team-availability.md (schedule field shape)

const WEEKDAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
]

const toHHMM = (date) => {
    const h = String(date.getHours()).padStart(2, '0')
    const m = String(date.getMinutes()).padStart(2, '0')
    return `${h}:${m}`
}

const toDateOrNull = (ts) => {
    if (!ts || typeof ts.toDate !== 'function') return null
    try {
        return ts.toDate()
    } catch (e) {
        return null
    }
}

// Compare two dates as calendar days only (ignore time-of-day) so EffectiveUntil
// is inclusive of the last day, not cut off at 00:00.
const startOfDay = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate())

const isTaskWithinPersonaSchedule = (task, personaSchedules) => {
    if (!task || task.Type === 'personaSchedule') return false
    if (!Array.isArray(personaSchedules) || personaSchedules.length === 0) return false

    const members = Array.isArray(task.TeamMembers) ? task.TeamMembers : []
    if (members.length === 0) return false

    const taskStart = toDateOrNull(task.Timestamp)
    const taskEnd = toDateOrNull(task.TimestampEnd)
    if (!taskStart || !taskEnd) return false

    const memberSet = new Set(members)
    const weekday = WEEKDAYS[taskStart.getDay()]
    const taskStartHHMM = toHHMM(taskStart)
    const taskEndHHMM = toHHMM(taskEnd)
    const taskDay = startOfDay(taskStart)

    return personaSchedules.some((sched) => {
        if (!sched || sched.Type !== 'personaSchedule') return false
        if (!memberSet.has(sched.PersonaID)) return false
        if (sched.Day !== weekday) return false
        if (typeof sched.StartTime !== 'string' || typeof sched.EndTime !== 'string') return false
        if (sched.StartTime > taskStartHHMM) return false
        if (sched.EndTime < taskEndHHMM) return false

        const from = toDateOrNull(sched.EffectiveFrom)
        if (from && startOfDay(from) > taskDay) return false

        const until = toDateOrNull(sched.EffectiveUntil)
        if (until && startOfDay(until) < taskDay) return false

        return true
    })
}

export default isTaskWithinPersonaSchedule
